import { z } from 'zod';
import { TenantDescriptionSchema, TenantSeatLimitsSchema, TenantSlugSchema, TenantSummarySchema, TenantTypeSchema } from '../../../../entities/tenant/tenant.schema';
/**
 * Request Schema for Updating a Tenant
 * Super-admin can update tenant details
 */ export const UpdateTenantRequestSchema = z.object({
    name: z.string().min(1, 'Name is required').optional(),
    slug: TenantSlugSchema.optional(),
    active: z.boolean().optional(),
    tenantType: TenantTypeSchema.optional(),
    expiresAt: z.iso.datetime().nullable().optional(),
    /** Partner firm's HubSpot company id (company-centric anchor for partners). */ hubspotPartnerCompanyId: z.string().optional(),
    /**
   * Confirm overwriting an existing HubSpot company↔tenant link. Transient
   * action flag (not persisted) — only honoured when the linked company already
   * points at a different tenant; otherwise ignored.
   */ forceHubspotLink: z.boolean().optional(),
    description: TenantDescriptionSchema.optional(),
    /**
   * Per-role seat caps. Applied per field: an explicit `null` clears that pool
   * back to unlimited, an omitted field leaves it unchanged.
   */ seatLimits: TenantSeatLimitsSchema.optional()
});
/**
 * Response Schema for Updating a Tenant
 */ export const UpdateTenantResponseSchema = z.object({
    message: z.string(),
    tenant: TenantSummarySchema
});

//# sourceMappingURL=update-tenant.schema.js.map